import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import CurriculumCard from "./curriculumCard";


const BiblePlan = ({ onNext, onCreatePlan, curriculum = [], onAddPlan }) => {
  const [activeTab, setActiveTab] = useState("Find Plans");
  const [searchText, setSearchText] = useState("");
  const filteredPlans = curriculum.filter((p) =>
    p.curriculum_name?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 gap-2">

         <input
          type="text"
          placeholder="Search Curriculum..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-[#1a1a1a] text-white border border-gray-600 outline-none"
        />
        <ArrowRight
          onClick={onNext}
          className="text-white w-6 h-6 cursor-pointer"
        />
      </div>


      {/* Category */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-sm font-semibold text-[#F8BA34]">Select a Curriculam</h2>
          <span className="text-[#F8BA34] text-sm cursor-pointer">{">"}</span>
        </div>

        {/* 2 ROW GRID */}
        <div className="grid grid-flow-col grid-rows-2 gap-4 overflow-x-auto pb-2">
          {filteredPlans.length > 0 ? (
            filteredPlans.map((curriculum, idx) => (
              <CurriculumCard
                key={idx}
                curriculum={curriculum}
                onAdd={() => onAddPlan(curriculum)}
              />
            ))
          ) : (
            <p className="text-gray-400 text-sm col-span-2">
              No Curriculam found
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BiblePlan;
